module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.5606",
      "hs-test-utils": "static-1.8194",
      "I18n": "static-7.1645",
      "jasmine-runner": "static-1.6627",
      "quartz": "static-1.7257",
      "hubspot-url-utils": "static-1.4261",
      "outpost": "static-1.4340",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.190",
      "moment": "static-3.26",
      "foundations-components": "static-1.8271",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3305",
      "msw": "static-1.39",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "redux": "static-4.16",
      "testing-library": "static-1.155",
      "enviro": "static-4.472",
      "i18n-data": "static-1.225",
      "metrics-js": "static-1.9811",
      "moment-timezone": "static-5.86",
      "react-utils": "static-2.5465",
      "StyleGuideUI": "static-3.491",
      "jasmine": "static-4.4496",
      "quartz-config": "static-1.1035",
      "webpack-env": "static-1.54",
      "quartz-core": "static-1.6476",
      "csstype": "static-1.50",
      "bend-plugin-foundations-components": "static-1.4540",
      "floating-ui": "static-1.60",
      "foundations-assets": "static-1.5045",
      "foundations-theming": "static-1.4611",
      "foundations-theming-specialty": "static-1.2327",
      "hs-story-utils": "static-1.9597",
      "react-aria": "static-1.69",
      "react-create-root-preference": "static-1.45",
      "react-select-plus": "static-1.108",
      "react-virtualized": "static-2.102",
      "styled-components": "static-2.93",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2279",
      "ui-fonts": "static-1.911",
      "ui-images": "static-2.1205",
      "bender-build-tools": "static-1.3301",
      "hoist-non-react-statics": "static-3.9",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "HeadJS": "static-2.777",
      "hub-http": "static-1.6392",
      "hub-http-janus": "static-1.852",
      "hubspotter-http": "static-1.4775",
      "icons": "static-2.665",
      "mobile-manifest-mixins": "static-1.551",
      "module-federation": "static-1.29",
      "PortalIdParser": "static-2.421",
      "quartz-auth": "static-1.932",
      "quartz-head": "static-1.922",
      "quartz-i18n": "static-1.932",
      "quartz-routing": "static-1.687",
      "quartz-test": "static-1.932",
      "quartz-tracking": "static-1.636",
      "quick-fetch": "static-1.4041",
      "raven": "static-3.6102",
      "raven-hubspot": "static-1.6409",
      "react-rhumb": "static-1-track-cwv-per-soft-navigation.19",
      "trellis-components": "static-1.2298",
      "UIComponents": "static-3.8595",
      "usage-tracker-container": "static-1.7514",
      "usage-tracker-core": "static-1.7374",
      "web-vitals": "static-1.9",
      "bend-plugin-foundations-theming": "static-1.3094",
      "foundations-theming-base": "static-1.3596",
      "stylex": "static-1.37",
      "classnames": "static-2.10",
      "react-input-autosize": "static-2.17",
      "hs-locale-management": "static-1.205",
      "sassPrefix": "static-1.159",
      "hub-http-shared-msw-handlers": "static-1.10393",
      "hubspotter-http-shared-msw-handlers": "static-1.10391",
      "hs-promise-rejection-tracking": "static-1.5761",
      "usage-tracker-session-replay": "static-1.5210",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "trellis-theming": "static-1.1120",
      "tanstack-virtual": "static-1.33",
      "cssUtils": "static-1.842",
      "head-dlb": "static-1.5007",
      "HubStyle": "static-2.11956",
      "HubStyleTokens": "static-2.11649",
      "ts-schema": "static-1.4204",
      "amplitude-session-replay-browser": "static-1.60"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.5606",
      "hs-test-utils": "/hs-test-utils/static-1.8194",
      "I18n": "/I18n/static-7.1645",
      "jasmine-runner": "/jasmine-runner/static-1.6627",
      "quartz": "/quartz/static-1.7257",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4261",
      "outpost": "/outpost/static-1.4340",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.190",
      "moment": "/moment/static-3.26",
      "foundations-components": "/foundations-components/static-1.8271",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3305",
      "msw": "/msw/static-1.39",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.155",
      "enviro": "/enviro/static-4.472",
      "i18n-data": "/i18n-data/static-1.225",
      "metrics-js": "/metrics-js/static-1.9811",
      "moment-timezone": "/moment-timezone/static-5.86",
      "react-utils": "/react-utils/static-2.5465",
      "StyleGuideUI": "/StyleGuideUI/static-3.491",
      "jasmine": "/jasmine/static-4.4496",
      "quartz-config": "/quartz-config/static-1.1035",
      "webpack-env": "/webpack-env/static-1.54",
      "quartz-core": "/quartz-core/static-1.6476",
      "csstype": "/csstype/static-1.50",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4540",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-assets": "/foundations-assets/static-1.5045",
      "foundations-theming": "/foundations-theming/static-1.4611",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2327",
      "hs-story-utils": "/hs-story-utils/static-1.9597",
      "react-aria": "/react-aria/static-1.69",
      "react-create-root-preference": "/react-create-root-preference/static-1.45",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-virtualized": "/react-virtualized/static-2.102",
      "styled-components": "/styled-components/static-2.93",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2279",
      "ui-fonts": "/ui-fonts/static-1.911",
      "ui-images": "/ui-images/static-2.1205",
      "bender-build-tools": "/bender-build-tools/static-1.3301",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "HeadJS": "/HeadJS/static-2.777",
      "hub-http": "/hub-http/static-1.6392",
      "hub-http-janus": "/hub-http-janus/static-1.852",
      "hubspotter-http": "/hubspotter-http/static-1.4775",
      "icons": "/icons/static-2.665",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
      "module-federation": "/module-federation/static-1.29",
      "PortalIdParser": "/PortalIdParser/static-2.421",
      "quartz-auth": "/quartz-auth/static-1.932",
      "quartz-head": "/quartz-head/static-1.922",
      "quartz-i18n": "/quartz-i18n/static-1.932",
      "quartz-routing": "/quartz-routing/static-1.687",
      "quartz-test": "/quartz-test/static-1.932",
      "quartz-tracking": "/quartz-tracking/static-1.636",
      "quick-fetch": "/quick-fetch/static-1.4041",
      "raven": "/raven/static-3.6102",
      "raven-hubspot": "/raven-hubspot/static-1.6409",
      "react-rhumb": "/react-rhumb/static-1-track-cwv-per-soft-navigation.19",
      "trellis-components": "/trellis-components/static-1.2298",
      "UIComponents": "/UIComponents/static-3.8595",
      "usage-tracker-container": "/usage-tracker-container/static-1.7514",
      "usage-tracker-core": "/usage-tracker-core/static-1.7374",
      "web-vitals": "/web-vitals/static-1.9",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3094",
      "foundations-theming-base": "/foundations-theming-base/static-1.3596",
      "stylex": "/stylex/static-1.37",
      "classnames": "/classnames/static-2.10",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-locale-management": "/hs-locale-management/static-1.205",
      "sassPrefix": "/sassPrefix/static-1.159",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10393",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10391",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5761",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5210",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "trellis-theming": "/trellis-theming/static-1.1120",
      "tanstack-virtual": "/tanstack-virtual/static-1.33",
      "cssUtils": "/cssUtils/static-1.842",
      "head-dlb": "/head-dlb/static-1.5007",
      "HubStyle": "/HubStyle/static-2.11956",
      "HubStyleTokens": "/HubStyleTokens/static-2.11649",
      "ts-schema": "/ts-schema/static-1.4204",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
    },
    "bundlingPackage": "feedback-knowledge-js",
    "bundlingPackageVersion": "static-1.5606",
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};